export default function Hero() {
  return (
    <section
      className="section-padding hero-bg min-h-[80vh] flex flex-col justify-center"
      style={{
        background: "linear-gradient(rgba(15, 23, 42, 0.7), rgba(15, 23, 42, 0.7)), url('/images/wallpapers/banner.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "scroll",
      }}
    >
      <div className="container px-4 sm:px-6">
        <div className="mx-auto flex max-w-6xl flex-col md:flex-row items-center md:items-start justify-center md:justify-between gap-8">
          {/* Left column: text + buttons */}
          <div className="max-w-2xl text-center md:text-left w-full flex-shrink-0">
            <p className="text-sm sm:text-base text-gray-300 mb-3 sm:mb-4 font-dm-sans font-medium">
              Taking creators to the next level
            </p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-4 sm:mb-6 leading-tight tracking-tight">
              The brand-ready media kit serious creators use.
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6 sm:mb-8 font-dm-sans leading-relaxed max-w-xl">
              Auto-updating performance metrics, structured in a format brands actually trust.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-3 sm:mb-4 w-full sm:w-auto">
              <a
                href="/signup"
                className="w-full sm:w-auto inline-flex items-center justify-center rounded-xl px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base font-semibold text-white bg-primary hover:bg-primary/90 transition-all duration-200 shadow-lg hover:shadow-xl font-dm-sans min-h-[48px]"
              >
                Create your profile
              </a>
              <a
                href="https://influencehub.net/bellabytheway"
                className="w-full sm:w-auto inline-flex items-center justify-center rounded-xl px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base font-semibold text-gray-200 border-2 border-gray-400/70 bg-transparent hover:bg-white/5 transition-all duration-200 font-dm-sans min-h-[48px]"
              >
                View example profile
              </a>
            </div>
            <p className="text-xs text-gray-400 font-dm-sans mb-4 sm:mb-6">
              Live engagement rate. Real average views. No outdated screenshots.
            </p>
            <p className="text-xs sm:text-sm text-gray-400 font-dm-sans flex items-center justify-center md:justify-start gap-2">
              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-white/10 flex-shrink-0" aria-hidden>
                <svg className="w-3 h-3 text-primary-light" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
              </span>
              Used by creators with 5 million+ combined followers
            </p>
          </div>
          {/* Right: profile preview card */}
          <div className="flex items-center justify-center w-full md:w-auto md:flex-shrink-0">
            <a
              href="https://influencehub.net/bellabytheway"
              target="_blank"
              rel="noopener noreferrer"
              className="relative rounded-2xl sm:rounded-3xl bg-white/5 backdrop-blur-md p-4 sm:p-6 border border-white/20 w-full max-w-[280px] sm:max-w-[320px] md:max-w-[400px] lg:max-w-[500px] hover:bg-white/10 hover:border-white/30 transition-all duration-300 cursor-pointer block shadow-xl hover:shadow-2xl ring-1 ring-white/5"
            >
              <div className="relative rounded-b-2xl sm:rounded-b-3xl overflow-hidden mx-auto">
                <img
                  src="/images/heroprofile.png"
                  alt="Professional creator profile example showing influencer media kit with stats, audience data, and brand collaborations"
                  className="w-full h-auto max-w-full object-contain block"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 h-12 sm:h-16 md:h-20 bg-gradient-to-t from-[rgba(15,23,42,0.7)] to-transparent pointer-events-none hidden md:block" />
              </div>
              <span className="sr-only">View example profile</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
